import { useQuery } from "react-query";
import DataRequest from "../queries/DataRequest";
import { GetPhotosResponse } from "../types/responses/GetPhotosResponse";

export const usePhotos = (inspectionId: string, user: any = null) => {
    return useQuery<GetPhotosResponse[]>("vesselPhotos", async () => {
        return await DataRequest(inspectionId, "photos", user);
    });
};
